import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import LoginModal from '../components/LoginModal';
import RegisterModal from '../components/RegisterModal';
import './Landing.scss';

export default function Landing() {
  const [modal, setModal] = useState(null);

  return (
    <>
      <div className="vintage-landing">
        <nav className="navbar">
          <span className="logo">StudyHelper</span>
          <div className="nav-buttons">
            <Button variant="outline-secondary" onClick={() => setModal('login')}>
              Anmelden
            </Button>
            <Button variant="primary" className="cta-nav-button" onClick={() => setModal('login')}>
              Jetzt starten
            </Button>
          </div>
        </nav>

        <Container className="hero-container">
          <h1 className="headline">
            Wissen trifft Gelegenheit.
          </h1>
          <p className="subline">
            Eine kuratierte Gemeinschaft für Studenten und Tutoren. Finden Sie Ihren Experten,
            buchen Sie Ihre Sitzung und entfalten Sie Ihr Potenzial.
          </p>
          <Button
            size="lg"
            onClick={() => setModal('register')}
            className="cta-primary"
          >
            Der Community beitreten
          </Button>
        </Container>

        <div className="how-it-works-section">
          <Container>
            <h2 className="section-title">So funktioniert's</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3 className="step-title">Dozenten finden</h3>
                <p className="step-description">
                  Nutzen Sie unsere leistungsstarke Suche und Filter, um den perfekten Dozenten nach Fach, Expertise und Verfügbarkeit zu finden.
                </p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h3 className="step-title">Sitzung buchen</h3>
                <p className="step-description">
                  Planen und buchen Sie Ihre Sitzung direkt über unsere sichere Plattform. Es ist einfach, schnell und zuverlässig.
                </p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h3 className="step-title">Lernen beginnen</h3>
                <p className="step-description">
                  Verbinden Sie sich mit Ihrem Dozenten über unsere integrierten Tools und beginnen Sie Ihre persönliche Lernreise.
                </p>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <LoginModal
        show={modal === 'login'}
        onHide={() => setModal(null)}
        onSwitchToRegister={() => setModal('register')}
      />
      <RegisterModal
        show={modal === 'register'}
        onHide={() => setModal(null)}
        onSwitchToLogin={() => setModal('login')}
      />
    </>
  );
}
